<template>
  <v-tab :value="index"><slot name="title" /></v-tab>
</template>

<script>
export default {
  name: 'BTab',
  props: {
    title: { type: String, default: '' },
    active: { type: Boolean, default: false }
  },
  computed: {
    index () {
      return this.$parent?.$children?.indexOf(this) ?? 0
    }
  }
}
</script>
